<template>
  <div id="game-wrapper" :class="{start: bStartScreen}" @click="bStartScreen = false" @touchstart.self.prevent="bStartScreen = false">
    <div id="object">
      <img src="../src/assets/kirche.png" alt="" />
      <p><span>© bpk / Scala</span></p>
      </div>
    <img id="title" src="../src/assets/title.jpg" alt="" />
    <div id="question">
      <h1>
        <span>
          {{question.text}}
        </span>
      </h1>
      <ul>
        <li v-for="answer in question.answers" :key="answer.id" :data-answer-id="answer.id" @click="onAnswerClick(answer.id)" @touchstart.self.prevent="onAnswerClick(answer.id)" :class="{current: (answer.id == selectedAnswerId)}">
          <span>{{ answer.text }}</span>
        </li>
      </ul>
    </div>
    <div>
      <div :class="{popup: true, show: (answer.id == selectedAnswerId)}" v-for="answer in question.answers" :key="answer.id" @click="selectedAnswerId = 0" @touchstart.self.prevent="selectedAnswerId = 0" v-html="answer.popup"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Multiple-Choice',
  data () {
    return {
      bStartScreen: true,
      selectedAnswerId: 0,
      question: {
        text: 'Où cette église a-t-elle été construite ?',
        answers: [
          {
            id: 1,
            text: 'À Rome',
            popup: '<h2>Exact !</h2> <p>L’église se trouve à Rome et a été dédiée à la Vierge Marie. C’est pourquoi elle s’appelle Santa Maria Maggiore en italien. </p><p>Aurais-tu reconnu cette église sur le tableau ?</p>'
          },
          {
            id: 2,
            text: 'À Madrid',
            popup: '<h2>Faux, désolé.</h2>'
          },
          {
            id: 3,
            text: 'À Paris',
            popup: '<h2>Faux, désolé.</h2>'
          }
        ]
      }
    }
  },
  created () {
  },
  methods: {
    onAnswerClick (id) {
      console.log('onAnswerClick()', id)
      this.selectedAnswerId = id
    }
  }
}
</script>
